export const DEFAULT_ORGANIZATION_TIMEZONE = "Europe/Berlin";

export const ORGANIZATION_TIMEZONES = [
    "Europe/Berlin",
    "Europe/Vienna",
    "Europe/Zurich",
    "Europe/Amsterdam",
    "Europe/Brussels",
    "Europe/Copenhagen",
] as const;

export type OrganizationTimezone = typeof ORGANIZATION_TIMEZONES[number];

export const isOrganizationTimezone = (value?: string | null): value is OrganizationTimezone => {
    return typeof value === "string" && ORGANIZATION_TIMEZONES.includes(value as OrganizationTimezone);
};

export const ORGANIZATION_TIMEZONE_LABELS: {[key in OrganizationTimezone]: string} = {
    "Europe/Berlin": "Europe/Berlin (Deutschland)",
    "Europe/Vienna": "Europe/Vienna (Österreich)",
    "Europe/Zurich": "Europe/Zurich (Schweiz)",
    "Europe/Amsterdam": "Europe/Amsterdam (Niederlande)",
    "Europe/Brussels": "Europe/Brussels (Belgien)",
    "Europe/Copenhagen": "Europe/Copenhagen (Dänemark)",
};
